import { BtnCss } from '../../utility/css';

interface HighLightableBtnProps {
  isActive: boolean;
  onClick: () => void;
  label: string;
}

export default function HighLightableBtn({ isActive, onClick, label }: HighLightableBtnProps) {
  return (
    <button
      type="button"
      className="px-[14px] py-[8px]"
      style={
        (isActive
          ? { ...BtnCss.Focused, borderRadius: '18px' }
          : { ...BtnCss.Blured, borderRadius: '20px' }) as React.CSSProperties
      }
      onClick={onClick}
    >
      {label}
    </button>
  );
}

